<template>
  <v-app>
    <!-- <login/> -->
  <!-- <div class="Dashboard"> -->
      <introduction />
      <!-- <Tabs/> -->
       
      <router-view />
      <!-- <router-view /> -->
       <!-- <md-tabs>
      <md-tab id="tab-home" md-label="Home" to="/vuematerial/components/tabs" exact>
        Home Tab
      </md-tab>

      <md-tab id="tab-pages" md-label="Pages" to="/vuematerial/components/tabs/pages">
        Pages tab
        <p>Unde provident nemo reiciendis officia, possimus repellendus. Facere dignissimos dicta quis rem. Aliquam aspernatur dolor atque nisi id deserunt laudantium quam repellat.</p>
      </md-tab>

      <md-tab id="tab-posts" md-label="Posts" to="/vuematerial/components/tabs/posts">
        Posts tab
        <p>Qui, voluptas repellat impedit ducimus earum at ad architecto consectetur perferendis aspernatur iste amet ex tempora animi, illum tenetur quae assumenda iusto.</p>
      </md-tab>

      <md-tab id="tab-favorites" md-label="Favorites" to="/vuematerial/components/tabs/favorites">
        Favorites tab
        <p>Maiores, dolorum. Beatae, optio tempore fuga odit aperiam velit, consequuntur magni inventore sapiente alias sequi odio qui harum dolorem sunt quasi corporis.</p>
      </md-tab>
    </md-tabs> -->
    <!-- <main class="main"> -->
      
        <!-- <input-container class="input-container-main" />
        <sample-dashboard :style="showSampleDashboard" view="SampleDashboard" /> 
        <heatmap-container :style="showHeatmap" view="Heatmap"  />
        <boxplot-container :style="showBoxplot" view="Boxplot" />
        <scatterplot-container :style="showScatterplot" view="Scatterplot" /> -->
        <!-- <quality-control-container :style="showQualityControl" view="Quality control" /> -->
        <!-- <histology-viewer-container :style="showHistologyViewer" view="Histology viewer" /> -->
    <!-- </main> -->
    <!-- </div> -->
  </v-app>
</template>

<script>
//   import Login from './components/Login.vue';
import BoxplotContainer from './components/Boxplot/BoxplotContainer.vue';
import HeatmapContainer from './components/Heatmap/HeatmapContainer.vue';
// import HistologyViewerContainer from './HistologyViewerContainer.vue';
import InputContainer from './components/InputContainer.vue';
import Introduction from './components/Header/Introduction.vue';
import ScatterplotContainer from './components/Scatterplot/ScatterplotContainer.vue';
import SampleDashboard from './components/SampleDashboard.vue';
// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'

// import Login from './components/Login.vue';
// import QualityControlContainer from './components/QualityControlContainer.vue';
import { mapState } from 'vuex';
// import Tabs from './Routerpages/Tabs.vue'

export default {
  name: 'App',

  components: {
  //   Login,
    // BoxplotContainer,
    // HeatmapContainer,
    // // HistologyViewerContainer,
    // InputContainer,
    Introduction,
    // Tabs
    // SampleDashboard,
    // ScatterplotContainer,
    // QualityControlContainer,
  },
  created(){
    // this.$store.dispatch('videos/loadAll');
    // this.$store.dispatch('users/loadCurrent');
    // this.$store.dispatch('tags/loadAll');
  },

  data: () => ({
  }),

  computed: {
    view() { return this.$store.state.view },
    showBoxplot() { return this.view === 'Boxplot' ? "" : "display: none;" },
    // showDemo() { return this.view === 'Demo' ? "" : "display: none;" },
    showHeatmap() { return this.view === 'Heatmap' ? "" : "display: none;" },
    // showIprofun() { return this.view === 'Iprofun' ? "" : "display: none;" },
    showSampleDashboard() { return this.view === 'Sample dashboard' ? "" : "display: none;" },
    showScatterplot() { return this.view === 'Scatterplot' ? "" : "display: none;" },
    showQualityControl() { return this.view === 'Quality control' ? "" : "display: none;" },
    showHistologyViewer() { return this.view === 'Histology viewer' ? "" : "display: none;" },
    ...mapState({
      currentUser: state => this.$store.state.users.currentUser, 
      // snackbars: state => state.snackbar.snackbars
    })
  },

  mounted() { 
      this.$store.dispatch('getTracks', 
          { 
            view: 'Heatmap', 
            genes: ['LXN', 'ARVCF'],
            combine_bool: true,
          }
        )
  }
};
</script>

<style scoped>
html {
    box-sizing: border-box;
}

*, *:before, *:after {
    box-sizing: inherit;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.main {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

.right-panel {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
</style>